import { render, staticRenderFns } from "./ItemsTable.vue?vue&type=template&id=544cb4b9&"
import script from "./ItemsTable.vue?vue&type=script&lang=js&"
export * from "./ItemsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports